import React from 'react';
export function SuccessMessage() {
  return <div className="min-h-screen w-full bg-white flex items-center justify-center" data-id="element-276">
      <div className="max-w-2xl mx-auto px-4 text-center load-fade-in-up" data-id="element-277">
        <div className="bg-surface rounded-2xl p-12" data-id="element-278">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-279">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-280">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-281" />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-ink mb-4" data-id="element-282">
            Thank You for Reaching Out
          </h2>
          <p className="text-lg text-gray-600" data-id="element-283">
            We've received your inquiry and will review it shortly. A member of
            our team will be in touch within 1-2 business days to discuss your
            project.
          </p>
        </div>
      </div>
    </div>;
}